<template>
  <div id="timer" v-show="false">
    <v-icon style="font-size: 20px;margin-right: 5px;color:#333333">alarm</v-icon>
    <span v-if="activeChild">
      {{ activeChild.played_time | msToTime }}
    </span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Timer',
  data() {
    return {
      timer: null,
      userActivityTimer: null,
    };
  },
  computed: {
    ...mapGetters({
      activeChild: 'children/activeChildProfile',
    }),
  },
  filters: {
    msToTime(duration) {
      let seconds = Math.floor((duration / 1000) % 60);
      let minutes = Math.floor((duration / (1000 * 60)) % 60);
      let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

      hours = hours < 10 ? `0${hours}` : hours;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      seconds = seconds < 10 ? `0${seconds}` : seconds;

      return `${hours}:${minutes}:${seconds}`;
    },
  },
  mounted() {
    window.addEventListener('focus', this.startTimer);
    window.addEventListener('blur', this.stopTimer);
    window.addEventListener('mousemove', this.stopTimerIfUserIdle, false);
    window.addEventListener('scroll', this.stopTimerIfUserIdle, false);
    window.addEventListener('keyup', this.stopTimerIfUserIdle, false);
    this.startTimer();
    this.setProfileActivity();
  },
  methods: {
    ...mapActions({
      runTimer: 'children/runTimer',
      resetTimer: 'children/resetTimer',
      saveActivity: 'children/saveActivity',
    }),
    startTimer() {
      if (!this.timer && this.activeChild) {
        this.timer = setInterval(() => {
          this.runTimer(this.activeChild.id);
        }, 1000);
      }
    },
    stopTimer() {
      window.clearInterval(this.timer);
      this.timer = null;
    },
    stopTimerIfUserIdle() {
      window.clearInterval(this.userActivityTimer);
      this.userActivityTimer = setInterval(() => {
        this.stopTimer();
      }, 120 * 1000);
      this.startTimer();
    },
    async setProfileActivity() {
      if (!this.activeChild) return;
      if (this.$moment(this.activeChild.last_played).local().diff(this.$moment(), 'days') !== 0) {
        this.resetTimer(this.activeChild);
      }
      try {
        const res = await this.saveActivity({
          child_id: this.activeChild.id,
          time: this.activeChild.played_time,
        });
        if (res.status === 200) {
          setTimeout(() => {
            this.setProfileActivity();
          }, 5000);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>

</style>
